var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionGrisVoirPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2,3.2c0-1.5,1.2-2.7,2.7-2.7c0,0,0.1,0,0.1,0c1.5-0.1,2.7,1,2.8,2.5c0,0.1,0,0.1,0,0.2c0,1.5-1.2,2.7-2.6,2.7 c-0.1,0-0.1,0-0.2,0c-1.5,0.1-2.7-1-2.8-2.5C9.2,3.3,9.2,3.2,9.2,3.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2,12c0-1.5,1.2-2.7,2.7-2.7c0,0,0.1,0,0.1,0c1.5,0,2.7,1.2,2.7,2.7s-1.2,2.7-2.7,2.7c-1.5,0.1-2.7-1-2.8-2.5 C9.2,12.1,9.2,12.1,9.2,12z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2,20.8c0-1.5,1.2-2.7,2.7-2.7c0,0,0.1,0,0.1,0c1.5,0,2.7,1.2,2.7,2.7s-1.2,2.7-2.7,2.7c-1.5,0.1-2.7-1.1-2.8-2.5 C9.2,20.9,9.2,20.9,9.2,20.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionGrisVoirPlus);
export default __webpack_public_path__ + "static/media/action_gris_voir-plus.521b9311.svg";
export { ForwardRef as ReactComponent };